// ── Shared stylesheets (created once, reused across all instances) ───────────

const tagSheet = new CSSStyleSheet();
tagSheet.replaceSync(`
  :host {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    font-family: var(--text-font-family);
    font-style: normal;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    background-color: var(--off-white);
    vertical-align: middle;
    text-wrap: nowrap;
    color: hsl(from var(--space-color, #44A1FF) h s calc(l * .333));
  }
  svg path {
    fill: hsl(from var(--space-color, #44A1FF) h s calc(l * .333));
  }
`);

const ARROW_SVG = `<svg fill="none" height="20" viewBox="0 0 21 20" width="21" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g stroke="#02090a" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m1.5 10h18"/><path d="m11.0996 18.4 8.4-8.40002-8.4-8.4"/></g></svg>`;

const LOCATION_SVG = `<svg fill="none" height="13" viewBox="0 0 10 13" width="10" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path clip-rule="evenodd" d="m8.99363 7.36154c.31121-.63352.50637-1.48718.50637-2.04692 0-2.76142-2.12665-4.766768-4.75-4.766768s-4.75 2.006638-4.75 4.768058c0 .55974.195163 1.41211.506371 2.04563.320467.65237.763989 1.31862 1.244169 1.94677.82059 1.07349 1.74824 2.03569 2.35178 2.62719.36309.3558.93227.3558 1.29536 0 .60354-.5915 1.53119-1.5537 2.35178-2.62719.48018-.62815.9237-1.2944 1.24417-1.94677zm-4.24363-.31369c1.10457 0 2-.89543 2-2s-.89543-2-2-2-2 .89543-2 2 .89543 2 2 2z" fill-rule="evenodd"/></svg>`;

const badgeSheet = new CSSStyleSheet();
badgeSheet.replaceSync(`
  :host {
    display: inline-block;
    padding: 4px 8px;
    font-family: var(--text-font-family);
    font-style: normal;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    border-radius: 100vw;
    background-color: var(--off-white);
    vertical-align: middle;
    text-wrap: nowrap;
    line-height: 20px;
  }
`);

const eventCardSheet = new CSSStyleSheet();
eventCardSheet.replaceSync(`
  :host {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    height: 100%;
  }
  h2 {
    font-family: var(--title-font-family);
    font-size: 28px;
    font-style: normal;
    font-weight: 350;
    line-height: 30px;
    margin: 0;
    color: var(--color-primary);
  }
  h3.time {
    color: var(--color-primary);
    font-family: var(--text-font-family);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }
  img {
    aspect-ratio: 16/9;
    width: 100%;
    height: auto;
    object-fit: cover;
    margin: 0 auto;
  }
  .no-image {
    display: block;
    aspect-ratio: 16/9;
    background-color: var(--space-color, #44A1FF);
    width: 100%;
    max-width: 350px;
    margin: 0 auto;
  }
  .date {
    display: flex;
    flex-wrap: wrap-reverse;
    flex-direction: row;
    gap: 16px;
    width: 100%;
    justify-content: space-between;
    & h3 {
      text-transform: uppercase;
      font-family: var(--text-font-family);
      font-size: 20px;
      line-height: 24px;
      margin: 0;
      color: var(--color-primary);
      letter-spacing: -0.24px;
      font-style: normal;
      font-weight: 700;
    }
  }
  .time-tags {
    display: flex;
    flex-direction: column;
    gap: 8px;
    & h3 {
      font-family: var(--text-font-family);
      font-style: normal;
      font-weight: 700;
      line-height: 22px;
      letter-spacing: -0.32px;
      margin: 0;
      padding: 0;
    }
    & ul {
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: row;
      gap: 8px;
      & li {
        list-style: none;
        margin: 0;
        padding: 0;
      }
    }
  }
  .footer {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: auto;
  }
  .button {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
    gap: 16px;
    text-decoration: none;
    font-family: var(--text-font-family);
    font-size: 20px;
    line-height: 20px;
    color: black;
    background-color: var(--space-color, #44A1FF);
    width: 100%;
  }
  .button::after {
    content: '';
    position: absolute;
    inset: 0;
  }
  .button .arrow {
    width: 0;
    opacity: 0;
    height: 20px;
    overflow: hidden;
    transition: width .25s, opacity .5s;
    position: relative;
  }
  .button .arrow svg {
    position: absolute;
    right: 0;
  }
  :host(:hover) .button .arrow {
    width: 21px;
    opacity: 1;
  }
  @media screen and (min-width: 726px) {
    img {
      max-width: 350px;
    }
    h2 {
      min-height: 210px;
      font-size: 34px;
      line-height: 36px;
    }
    .date h3 {
      font-size: 22px;
      line-height: 26px;
    }
  }
  @media screen and (min-width: 1024px) {
    h2 {
      font-size: 40px;
      line-height: 42px;
    }
    .date h3 {
      font-size: 24px;
      line-height: 28px;
    }
  }

  /* ── Skeleton loading state ── */

  @keyframes shimmer {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
  }
  .skeleton {
    background: var(--light-gray, #e5e5e5);
    animation: shimmer 1.5s ease-in-out infinite;
    border-radius: 4px;
  }
  .skeleton-image {
    aspect-ratio: 16/9;
    width: 100%;
    border-radius: 0;
  }
  .skeleton-date {
    height: 24px;
    width: 30%;
  }
  .skeleton-title {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .skeleton-title-line {
    height: 28px;
  }
  .skeleton-time {
    height: 22px;
    width: 50%;
  }
  .skeleton-tags {
    display: flex;
    gap: 8px;
  }
  .skeleton-tag {
    height: 28px;
    width: 80px;
    border-radius: 0;
  }
  .skeleton-button {
    height: 68px;
    width: 100%;
    border-radius: 0;
  }
  @media screen and (min-width: 726px) {
    .skeleton-title {
      min-height: 210px;
    }
    .skeleton-title-line {
      height: 34px;
    }
  }
`);

// ── Component definition ──────────────────────────────────────────────────────

if (!customElements.get('spaces-event-card')) {
  customElements.define('spaces-event-card', class extends HTMLElement {

    connectedCallback() {
      this.render();
    }

    render() {
      const shadowRoot = this.shadowRoot || this.attachShadow({ mode: 'open' });
      shadowRoot.adoptedStyleSheets = [eventCardSheet];

      const title = this.getAttribute('title');
      if (!title) {
        shadowRoot.innerHTML = `
          <div class="skeleton skeleton-image"></div>
          <div class="skeleton skeleton-date"></div>
          <div class="skeleton-title">
            <div class="skeleton skeleton-title-line" style="width: 90%"></div>
            <div class="skeleton skeleton-title-line" style="width: 70%"></div>
            <div class="skeleton skeleton-title-line" style="width: 40%"></div>
          </div>
          <div class="footer">
            <div class="time-tags">
              <div class="skeleton skeleton-time"></div>
              <div class="skeleton-tags">
                <div class="skeleton skeleton-tag"></div>
                <div class="skeleton skeleton-tag"></div>
              </div>
            </div>
            <div class="skeleton skeleton-button"></div>
          </div>
        `;
        return;
      }

      const rsvpLink = this.getAttribute('rsvp-link') || '#';
      const imageUrl = this.getAttribute('image-url');
      const imageAlt = this.getAttribute('image-alt') || '';
      const startDate = this.getAttribute('start-date');
      const endDate = this.getAttribute('end-date');
      const badge = this.getAttribute('badge');

      const type = this.getAttribute('type') || 'Community';
      const space = {
        label: this.getAttribute('space-label') || '',
        color: this.getAttribute('space-color') || '#44A1FF',
      };

      // Set CSS custom property for dynamic color — inherited by child shadow DOMs
      this.style.setProperty('--space-color', space.color);

      const dateRangeHtml = this.#formatDateRange(startDate, endDate);
      const timeRangeHtml = this.#formatTimeRange(startDate, endDate);

      const imageHtml = imageUrl
        ? `<img src="${imageUrl}" width="350" height="196" loading="lazy" alt="${imageAlt}" />`
        : `<span class="no-image"></span>`;

      const badgeHtml = badge
        ? `<spaces-badge>${badge}</spaces-badge>`
        : '';

      shadowRoot.innerHTML = `
        ${imageHtml}
        <div class="date">
          <h3>${dateRangeHtml}</h3>
          ${badgeHtml}
        </div>
        <h2>${title}</h2>
        <div class="footer">
          <div class="time-tags">
            <h3>${timeRangeHtml}</h3>
            <ul>
              <li><spaces-tag glyph="location">${space.label}</spaces-tag></li>
              <li><spaces-tag>${type}</spaces-tag></li>
            </ul>
          </div>
          <a href="${rsvpLink}" target="_blank" rel="noopener noreferrer" class="button">
            RSVP
            <span class="arrow">${ARROW_SVG}</span>
          </a>
        </div>
      `;

      shadowRoot.querySelectorAll('spaces-tag').forEach(tag => {
        const glyph = tag.getAttribute('glyph');
        const shadow = tag.attachShadow({ mode: 'open' });
        shadow.adoptedStyleSheets = [tagSheet];
        shadow.innerHTML = (glyph === 'location' ? LOCATION_SVG : '') + '<slot></slot>';
      });

      shadowRoot.querySelectorAll('spaces-badge').forEach(badge => {
        const shadow = badge.attachShadow({ mode: 'open' });
        shadow.adoptedStyleSheets = [badgeSheet];
        shadow.innerHTML = '<slot></slot>';
      });
    }

    #formatDateRange(startDateStr, endDateStr) {
      if (!startDateStr) return '';
      const start = new Date(startDateStr);
      const end = endDateStr ? new Date(endDateStr) : start;
      
      // Display the stored dates in US Eastern Time (ET) without converting to
      // the viewer's local timezone. Route every part through the same timeZone so
      // the month name, day, and year always agree.
      const TZ = 'America/New_York';
      const startMonth = start.toLocaleDateString('en-US', { month: 'short', timeZone: TZ }).toUpperCase();
      const endMonth = end.toLocaleDateString('en-US', { month: 'short', timeZone: TZ }).toUpperCase();
      const startDay = Number(start.toLocaleDateString('en-US', { day: 'numeric', timeZone: TZ }));
      const endDay = Number(end.toLocaleDateString('en-US', { day: 'numeric', timeZone: TZ }));
      const startMonthIdx = Number(start.toLocaleDateString('en-US', { month: 'numeric', timeZone: TZ }));
      const endMonthIdx = Number(end.toLocaleDateString('en-US', { month: 'numeric', timeZone: TZ }));
      const startYear = Number(start.toLocaleDateString('en-US', { year: 'numeric', timeZone: TZ }));
      const endYear = Number(end.toLocaleDateString('en-US', { year: 'numeric', timeZone: TZ }));
      
      const sameDay = startYear === endYear && startMonthIdx === endMonthIdx && startDay === endDay;
      const sameMonth = startMonthIdx === endMonthIdx && startYear === endYear;
      
      if (sameDay) {
        return `${startMonth}&nbsp;${startDay}`;
      } else if (sameMonth) {
        return `${startMonth}&nbsp;${startDay} – ${endDay}`;
      } else {
        return `${startMonth}&nbsp;${startDay} – ${endMonth}&nbsp;${endDay}`;
      }
    }

    #formatTimeRange(startDateStr, endDateStr) {
      if (!startDateStr) return '';
      const start = new Date(startDateStr);
      const end = endDateStr ? new Date(endDateStr) : start;
      
      const formatTime = (date) => {
        return date.toLocaleTimeString('en-US', { 
          hour: 'numeric', 
          minute: '2-digit',
          hour12: true,
          timeZone: 'America/New_York'
        });
      };
      
      return `${formatTime(start)} – ${formatTime(end)}`;
    }

  });
}
